import { FaqItem } from '../../../shared/components/faq/faq.component';

/**
 * Questions on /info/data-sources. `app-faq` renders them as plain text and
 * emits the same array as FAQPage JSON-LD.
 *
 * No data years here on purpose: what the API serves lags the newest public
 * release, so a year written down in copy goes stale or overstates.
 */
export const DATA_SOURCES_FAQ: FaqItem[] = [
  {
    question: 'Where does Map AI data come from?',
    answer:
      'From three kinds of sources. Official government datasets: the U.S. ' +
      'Census Bureau, the CDC, the FBI, the U.S. Department of Education, ' +
      'the National Center for Education Statistics and the Bureau of Health ' +
      'Workforce. Open-source geographic information from OpenStreetMap, plus ' +
      'points of interest from Mapbox. And traffic intelligence from Ticon, ' +
      'the company behind Map AI, and TrafficZoom.',
  },
  {
    question: 'Who is Ticon, and why do you trust its traffic data?',
    answer:
      'Ticon is where Map AI started: we have been building location ' +
      'intelligence there since 2016. Its traffic data combines permanent ' +
      'and portable traffic detectors, traffic counters, GPS and connected ' +
      'vehicle data, and it is what we have used for years to help businesses ' +
      'choose new locations.',
  },
  {
    question: 'What is Mapbox data used for?',
    answer:
      'Besides the base map, Mapbox points of interest power the target POI ' +
      'analysis in our sales forecasts: the competitors and nearby amenities, ' +
      'such as parking and transit, around the address you are considering.',
  },
  {
    question: 'How current is the data?',
    answer:
      'Each source is updated as its publisher releases new data. Census ' +
      'demographics follow the American Community Survey 5-year releases, ' +
      'traffic counts reflect the most recent full year, and Mapbox points of ' +
      'interest are updated continuously.',
  },
  {
    question: 'How detailed is the data?',
    answer:
      'You can compare states, counties and cities, and the map goes down to ' +
      '1-mile resolution, so you can judge a specific neighborhood rather ' +
      'than a whole ZIP code.',
  },
  {
    question: 'Is the data the same for every location?',
    answer:
      'Every indicator is measured the same way everywhere it is available, ' +
      'so two locations can be compared side by side. Coverage follows the ' +
      'publisher: for example, crime data depends on which local police ' +
      'departments report to the FBI.',
  },
];
